import { BranchListPage } from '@/features/branch/pages/BranchListPage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/branch/')({
  validateSearch: (search: Record<string, unknown>) => search,
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["branch.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: BranchListPage,
})
